"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { MapPin, Phone, Mail, ShieldCheck, Award, CircleCheck, Loader, ArrowRight } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors duration-200">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/SoftwareAndIntelligencePage" className="text-muted-foreground hover:text-primary transition-colors duration-200">Software</Link>
        </li>
        <li data-index={2}>
          <Link to="/PilotTrainingPage" className="text-muted-foreground hover:text-primary transition-colors duration-200">Treinamento</Link>
        </li>
        <li data-index={3}>
          <Link to="/EquipmentRentalPage" className="text-muted-foreground hover:text-primary transition-colors duration-200">Locação</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-200 flex items-center gap-2 group">
            <ArrowRight className="size-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-primary" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-4 bg-primary/10 border border-primary/20 rounded-lg">
        <p className="text-primary text-sm font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="email" rules={{
      required: "E-mail é obrigatório",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "E-mail inválido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input type="email" placeholder="Seu melhor e-mail" className="bg-background border-border focus-visible:ring-primary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <p className="text-destructive text-sm">{submitError}</p>}

      <Button type="submit" disabled={isSubmitting} className="w-full group">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            Processando...
          </> : <>
            Assinar Newsletter
            <ArrowRight className="ml-2 size-4 group-hover:translate-x-1 transition-transform" />
          </>}
      </Button>
    </Form>;
}
export default function CorporateFooter() {
  return <section id="rodapé-corporativo" className="dark bg-background text-foreground py-16 px-4 md:px-8 border-t border-border/50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-4">
            <Link to="/HomePage" className="inline-block">
              <img src="https://enjoyed-bug.10web.cloud/wp-content/uploads/2026/03/Logo_volither_dark-1.png" className="h-7 w-auto" alt="Volither Logo" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Soluções completas de drones, software proprietário e treinamento especializado para inspeções industriais em ambientes confinados.
            </p>
          </div>

          {/*
           {}
           <div className="space-y-4">
           {/*<h3 className="text-lg font-semibold tracking-tight">Links Rápidos</h3>
            <MenuProvider menu_id="23" className="footer-menu-wrapper">
              <FooterMenuConsumer />
            </MenuProvider>
           </div>
           */}
          
          {/*
            {}
           <div className="space-y-4">
            <h3 className="text-lg font-semibold tracking-tight">Contato e Suporte</h3>
            <ul className="space-y-2">
              <li data-index={0} className="flex items-start gap-3 text-muted-foreground text-sm">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>Rua Bananeiras, 361, Manaíra, sala 107, João Pessoa - PB, CEP 58.038-170</span>
              </li>
              <li data-index={1} className="flex items-center gap-3 text-muted-foreground text-sm">
                <Phone className="size-5 text-primary shrink-0" />
                <span>+55 83 99911-5577</span>
              </li>
              <li data-index={2} className="flex items-center gap-3 text-muted-foreground text-sm">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:contato@volither.com" className="hover:text-primary transition-colors duration-200">
                  contato@volither.com
                </Link>
              </li>
            </ul>
           </div>
           */}

          {}
          <div className="space-y-4">
             <h3 className="text-lg font-semibold tracking-tight">Contato e Suporte</h3>
            <ul className="space-y-2">
              <li data-index={0} className="flex items-start gap-3 text-muted-foreground text-sm">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>Rua Bananeiras, 361, Manaíra, sala 107, João Pessoa - PB, CEP 58.038-170</span>
              </li>
              <li data-index={1} className="flex items-center gap-3 text-muted-foreground text-sm">
                <Phone className="size-5 text-primary shrink-0" />
                <span>+55 83 99911-5577</span>
              </li>
              <li data-index={2} className="flex items-center gap-3 text-muted-foreground text-sm">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:contato@volither.com" className="hover:text-primary transition-colors duration-200">
                  contato@volither.com
                </Link>
              </li>
            </ul>
            {/*
             <h3 className="text-lg font-semibold tracking-tight">Newsletter</h3>
             <p className="text-muted-foreground text-sm">
              Receba atualizações sobre nossas tecnologias e inovações no setor industrial.
             </p>
             <FormProvider formId="newsletter-footer" sectionName="rodape-corporativo" defaultValues={{
             email: ""
             }} validationRules={{
             email: {
              required: true,
              pattern: "email"
             }
             }} submitText="Assinar" successMessage="Inscrição realizada com sucesso!">
              <NewsletterForm />
             </FormProvider>
             */}
          </div>

        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-muted-foreground text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} Volither. Todos os direitos reservados.
          </p>
          
          <div className="flex items-center gap-6 text-muted-foreground">
            <div className="flex items-center gap-2 group cursor-help" title="Certificação de Segurança">
              <ShieldCheck className="size-5 group-hover:text-primary transition-colors duration-300" />
              <span className="sr-only">Certificação de Segurança</span>
            </div>
            <div className="flex items-center gap-2 group cursor-help" title="Padrão de Qualidade">
              <Award className="size-5 group-hover:text-primary transition-colors duration-300" />
              <span className="sr-only">Padrão de Qualidade</span>
            </div>
            <div className="flex items-center gap-2 group cursor-help" title="Conformidade Industrial">
              <CircleCheck className="size-5 group-hover:text-primary transition-colors duration-300" />
              <span className="sr-only">Conformidade Industrial</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}